import React from 'react';
import styles from './MetricValue.module.css';

interface MetricValueProps {
  value: string;
  className?: string;
}

export const MetricValue: React.FC<MetricValueProps> = ({
  value,
  className,
}) => {
  return (
    <span className={`${styles.metricValue} ${className || ''}`}>
      <span className={styles.metricValueText}>{value}</span>
    </span>
  );
};
